import { render, staticRenderFns } from "./secureMobile.vue?vue&type=template&id=236fbd3e&scoped=true"
import script from "./secureMobile.vue?vue&type=script&lang=js"
export * from "./secureMobile.vue?vue&type=script&lang=js"
import style0 from "./secureMobile.vue?vue&type=style&index=0&id=236fbd3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236fbd3e",
  null
  
)

export default component.exports